/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Lessons_Waiting_CountInputs */

const en_lessons_waiting_count = /** @type {(inputs: Lessons_Waiting_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} lessons waiting to be confirmed.`)
};

const he_lessons_waiting_count = /** @type {(inputs: Lessons_Waiting_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} שיעורים ממתינים לאישור.`)
};

/**
* | output |
* | --- |
* | "{count} lessons waiting to be confirmed." |
*
* @param {Lessons_Waiting_CountInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lessons_waiting_count = /** @type {((inputs: Lessons_Waiting_CountInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_Waiting_CountInputs, { locale?: "en" | "he" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lessons_waiting_count(inputs)
	return he_lessons_waiting_count(inputs)
});